var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "Modal",
    {
      attrs: { title: "总监角色部门信息", width: 60 },
      on: { "on-visible-change": _vm.onShowChange },
      model: {
        value: _vm.show,
        callback: function ($$v) {
          _vm.show = $$v
        },
        expression: "show",
      },
    },
    [
      _vm.$globalSpin
        ? _c("Spin", { attrs: { size: "large", fix: "" } })
        : _vm._e(),
      _c(
        "Form",
        {
          ref: "modelForm",
          staticClass: "small-form",
          attrs: {
            model: _vm.modelForm,
            rules: _vm.ruleValidate,
            "label-position": "top",
          },
        },
        [
          _c(
            "Row",
            { attrs: { gutter: 16 } },
            [
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "选择角色", prop: "roleId" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { filterable: "", clearable: "" },
                          model: {
                            value: _vm.modelForm.roleId,
                            callback: function ($$v) {
                              _vm.$set(_vm.modelForm, "roleId", $$v)
                            },
                            expression: "modelForm.roleId",
                          },
                        },
                        _vm._l(_vm.roleList, function (item) {
                          return _c("Option", {
                            key: item.roleUuid,
                            attrs: { value: item.roleUuid, label: item.name },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "选择公司", prop: "projectCompany" } },
                    [
                      _c(
                        "Select",
                        {
                          attrs: { filterable: "", clearable: "" },
                          on: { "on-change": _vm.onCompanyChange },
                          model: {
                            value: _vm.modelForm.projectCompany,
                            callback: function ($$v) {
                              _vm.$set(_vm.modelForm, "projectCompany", $$v)
                            },
                            expression: "modelForm.projectCompany",
                          },
                        },
                        _vm._l(_vm.companyList, function (item) {
                          return _c("Option", {
                            key: item.projectCompany,
                            attrs: {
                              value: item.projectCompany,
                              label: item.projectCompany,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "24" } },
                [
                  _c(
                    "FormItem",
                    {
                      attrs: {
                        label: "选择部门(支持多选)",
                        prop: "seedFarmIds",
                      },
                    },
                    [
                      _c(
                        "Select",
                        {
                          attrs: {
                            filterable: "",
                            multiple: "",
                            clearable: "",
                          },
                          model: {
                            value: _vm.modelForm.seedFarmIds,
                            callback: function ($$v) {
                              _vm.$set(_vm.modelForm, "seedFarmIds", $$v)
                            },
                            expression: "modelForm.seedFarmIds",
                          },
                        },
                        _vm._l(_vm.deptList, function (item) {
                          return _c("Option", {
                            key: item.seedFarmUuid,
                            attrs: {
                              value: item.seedFarmUuid,
                              label: item.seedFarmName,
                            },
                          })
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "Col",
                { attrs: { span: "6" } },
                [
                  _c(
                    "FormItem",
                    { attrs: { label: "状态", prop: "recordStatus" } },
                    [
                      _c(
                        "RadioGroup",
                        {
                          attrs: { type: "button" },
                          model: {
                            value: _vm.modelForm.recordStatus,
                            callback: function ($$v) {
                              _vm.$set(_vm.modelForm, "recordStatus", $$v)
                            },
                            expression: "modelForm.recordStatus",
                          },
                        },
                        _vm._l(_vm.statusSource, function (item) {
                          return _c(
                            "Radio",
                            { key: item.val, attrs: { label: item.val } },
                            [
                              _vm._v(
                                _vm._s(item.label) +
                                  "\n                        "
                              ),
                            ]
                          )
                        }),
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "div",
        { attrs: { slot: "footer" }, slot: "footer" },
        [
          _c(
            "Button",
            { attrs: { type: "primary" }, on: { click: _vm.onSave } },
            [_vm._v("确认")]
          ),
          _c(
            "Button",
            { attrs: { type: "error" }, on: { click: _vm.onCancel } },
            [_vm._v("取消")]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }